import { useState } from 'react';
import { useServerInfo } from '@go-client/context/ServerInfoContext';
import { getMandatoryFormFields } from '@go-shared/lib/brand';
import { BrandFormFieldName } from '@go-shared/types/brand';
import { GroupForm } from '@go-client/components/GroupBookingForm/Workflows';

export type GroupDetailsFieldName = BrandFormFieldName | 'name';

export function isFieldValueEmpty(groupForm: GroupForm, fieldName: GroupDetailsFieldName): boolean {
  const value = groupForm[fieldName];
  if (typeof value === 'string') return value.trim().length === 0;
  return value === undefined || value === null;
}

// Shared by any page that renders EnterGroupPageFields, so asterisks/errors/submit-gating stay
// consistent wherever group details are entered (EnterGroupPage, SelectGroupPage, ...).
export function useGroupDetailsValidation(groupForm: GroupForm) {
  const { brand } = useServerInfo();
  const [touchedFields, setTouchedFields] = useState<Set<GroupDetailsFieldName>>(new Set());

  const mandatoryFields = new Set<GroupDetailsFieldName>([
    'name',
    ...getMandatoryFormFields(brand, 'group_party'),
  ]);

  const formValid = [...mandatoryFields].every(
    fieldName => !isFieldValueEmpty(groupForm, fieldName)
  );

  function handleFieldBlur(fieldName: GroupDetailsFieldName) {
    setTouchedFields(prev => (prev.has(fieldName) ? prev : new Set(prev).add(fieldName)));
  }

  return { mandatoryFields, touchedFields, formValid, handleFieldBlur };
}
